
import { motion, AnimatePresence } from "framer-motion"
import styled from "@emotion/styled"
import { Check, ShoppingCart } from "lucide-react"
import { useEffect } from "react"

const ModalOverlay = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`

const ModalContent = styled(motion.div)`
  background: linear-gradient(135deg, #1a1a1a, #2a2a2a);
  padding: 2rem;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  text-align: center;
  max-width: 90%;
  width: 400px;
  position: relative;
  overflow: hidden;
`

const SuccessIcon = styled(motion.div)`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: #008000;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto 1rem;
`

const Title = styled(motion.h2)`
  color: #ffffff;
  margin-bottom: 1rem;
`

const Message = styled(motion.p)`
  color: #cccccc;
`

const ConfettiPiece = styled(motion.div)`
  position: absolute;
  width: 10px;
  height: 10px;
  background: ${(props) => props.color};
  border-radius: 50%;
`


export function AddToCartModal({ isOpen, onClose, name }) {
  useEffect(() => {
    if (isOpen) {
      const timer = setTimeout(() => {
        onClose()
      }, 3000)
      return () => clearTimeout(timer)
    }
  }, [isOpen, onClose])

  const confettiColors = ["#008000", "#00ff00", "#ffffff", "#ffff00"]

  return (
    <AnimatePresence>
      {isOpen && (
        <ModalOverlay initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} onClick={onClose}>
          <ModalContent
            initial={{ scale: 0.8, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.8, opacity: 0, y: 20 }}
            transition={{ type: "spring", damping: 15 }}
            onClick={(e) => e.stopPropagation()}
          >
            {[...Array(20)].map((_, i) => (
              <ConfettiPiece
                key={i}
                color={confettiColors[i % confettiColors.length]}
                initial={{
                  x: Math.random() * 400 - 200,
                  y: Math.random() * 400 - 200,
                  scale: 0,
                  rotate: Math.random() * 360,
                }}
                animate={{
                  x: Math.random() * 400 - 200,
                  y: Math.random() * 400 - 200,
                  scale: [0, 1, 0],
                  rotate: Math.random() * 360,
                }}
                transition={{
                  duration: 1.5,
                  repeat: Number.POSITIVE_INFINITY,
                  repeatType: "loop",
                  delay: Math.random() * 0.5,
                }}
              />
            ))}
            <SuccessIcon
              initial={{ scale: 0, rotate: -180 }}
              animate={{ scale: 1, rotate: 0 }}
              transition={{ type: "spring", stiffness: 200, delay: 0.2 }}
            >
              <motion.div
                initial={{ opacity: 0, scale: 0 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ delay: 0.5 }}
              >
                <Check size={40} color="#ffffff" />
              </motion.div>
            </SuccessIcon>
            <Title initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.3 }}>
              ¡Añadido al carrito!
            </Title>
            <Message initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.4 }}>
              Tu {name} ha sido añadida al carrito con éxito.
            </Message>
            <motion.div
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ type: "spring", stiffness: 200, delay: 0.6 }}
            >
              <ShoppingCart size={30} color="#008000" style={{ marginTop: "1rem" }} />
            </motion.div>
          </ModalContent>
        </ModalOverlay>
      )}
    </AnimatePresence>
  )
}

